import { useMutation, useQueryClient } from '@tanstack/react-query'
import { companyRequest } from '@/shared/api'
import { type Company, type CompanyInput, CompanyResponseSchema } from '../model/types'
import { companyKeys } from './queries'

export function useCreateCompany() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (input: CompanyInput): Promise<Company> => {
      const body = await companyRequest<unknown>({
        method: 'POST',
        path: '/companies',
        body: input,
      })
      return CompanyResponseSchema.parse(body).data
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: companyKeys.all })
    },
  })
}

export function useUpdateCompany(id: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (input: CompanyInput): Promise<Company> => {
      const body = await companyRequest<unknown>({
        method: 'PATCH',
        path: `/companies/${id}`,
        body: input,
      })
      return CompanyResponseSchema.parse(body).data
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: companyKeys.all })
    },
  })
}

// Компания не удаляется — только archive/unarchive (инвариант § 2).
export function useArchiveCompany(id: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (archived: boolean): Promise<void> => {
      await companyRequest<unknown>({
        method: 'POST',
        path: `/companies/${id}/${archived ? 'archive' : 'unarchive'}`,
      })
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: companyKeys.all })
    },
  })
}
